import {useEffect, useRef, useState} from "react";

export const useOnScreenObserver = (elementId: string | undefined, observerOptions?: IntersectionObserverInit) => {
    const [isOnScreen, setIsOnScreen] = useState(false);
    const observerRef = useRef<IntersectionObserver | null>(null);
    const observerTargetRef = useRef<Element | null>(null);
    const options: IntersectionObserverInit = observerOptions || {
        threshold: 1
    };

    useEffect(() => {
        if (typeof document !== "undefined") {
            observerTargetRef.current = document.querySelector(`#${elementId}`);
        }

        observerRef.current = new IntersectionObserver(([entry]) => {
            setIsOnScreen(entry.isIntersecting);
        }, options);

        return () => {
            observerRef.current?.disconnect();
        };
    }, []);

    const startObserver = () => {
        if (observerTargetRef.current) {
            observerRef.current?.observe(observerTargetRef.current);
        } else {
            console.error(`Element ${elementId} does not exist`);
        }
    };

    const stopObserver = () => {
        observerRef.current?.disconnect();
    };

    return {isOnScreen, startObserver, stopObserver};
};
import {useEffect, useRef, useState} from "react";

export const useOnScreenObserver = (elementId: string | undefined, observerOptions?: IntersectionObserverInit) => {
    const [isOnScreen, setIsOnScreen] = useState(false);
    const observerRef = useRef<IntersectionObserver | null>(null);
    const observerTargetRef = useRef<Element | null>(null);
    const options: IntersectionObserverInit = observerOptions || {
        threshold: 1
    };

    useEffect(() => {
        if (typeof document !== "undefined") {
            observerTargetRef.current = document.querySelector(`#${elementId}`);
        }

        observerRef.current = new IntersectionObserver(([entry]) => {
            setIsOnScreen(entry.isIntersecting);
        }, options);

        return () => {
            observerRef.current?.disconnect();
        };
    }, []);

    const startObserver = () => {
        if (observerTargetRef.current) {
            observerRef.current?.observe(observerTargetRef.current);
        } else {
            console.error(`Element ${elementId} does not exist`);
        }
    };

    const stopObserver = () => {
        observerRef.current?.disconnect();
    };

    return {isOnScreen, startObserver, stopObserver};
};
